export default "__VITE_ASSET__6325ddd9__"